import { useEffect, useRef, useState } from 'react';
import { getViralLinkIframeSrc } from '../utils/urls';
import { onIframeResizeMessage } from '../utils/postMessageUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EmbeddedViralLink({
  langOverride,
  linkType,
  portalId,
  additionalParams
}) {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState();
  useEffect(() => {
    onIframeResizeMessage({
      iframeRef,
      onMessage: value => {
        setIframeHeight(parseInt(value, 10));
      }
    });
  }, [iframeRef]);
  return /*#__PURE__*/_jsx("iframe", {
    style: {
      width: '100%',
      border: 'none',
      height: `${iframeHeight || 0}px`
    },
    "aria-label": `hubspot-${linkType}-viral-iframe`,
    "data-test-id": "viral-link-iframe",
    ref: iframeRef,
    src: getViralLinkIframeSrc(linkType, Object.assign({
      lang: langOverride,
      portalId
    }, additionalParams))
  });
}